/*
 * Cinema Cellar - RPS preorder stock shim
 *
 * Restores RPS's purchasable sentinel for preorder products that RPS reports
 * with non-positive stock so STOQ can render the native preorder button.
 * Fail-safe behavior returns the original response unchanged on any error.
 */
(function () {
  'use strict';

  var SENTINEL = 1000;

  function isRpsSearchUrl(url) {
    return typeof url === 'string' && /rapid-product-search.*\/search\//.test(url);
  }

  function clampPreorderStock(json, sentinel) {
    if (!json || !Array.isArray(json.products)) return 0;

    var changed = 0;
    json.products.forEach(function (product) {
      if (
        product &&
        product.isPreOrder === true &&
        typeof product.stock === 'number' &&
        product.stock <= 0
      ) {
        product.stock = sentinel;
        changed++;
      }
    });

    return changed;
  }

  function installFetchHook(win) {
    if (!win || typeof win.fetch !== 'function' || win.__ccPreorderShimInstalled) return;

    win.__ccPreorderShimInstalled = true;

    var originalFetch = win.fetch;
    win.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var responsePromise = originalFetch.apply(this, arguments);

      if (!isRpsSearchUrl(url)) {
        return responsePromise;
      }

      return responsePromise.then(function (response) {
        return response.clone().text().then(function (body) {
          try {
            var json = JSON.parse(body);
            var changed = clampPreorderStock(json, SENTINEL);

            if (!changed) {
              return response;
            }

            return new Response(JSON.stringify(json), {
              status: response.status,
              statusText: response.statusText,
              headers: response.headers,
            });
          } catch (error) {
            return response;
          }
        }).catch(function () {
          return response;
        });
      }).catch(function (error) {
        throw error;
      });
    };
  }

  if (typeof window !== 'undefined') {
    try {
      installFetchHook(window);
    } catch (error) {
      // Fail-safe: leave fetch untouched if bootstrap fails.
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      isRpsSearchUrl: isRpsSearchUrl,
      clampPreorderStock: clampPreorderStock,
      installFetchHook: installFetchHook,
      SENTINEL: SENTINEL,
    };
  }
})();
